import { types } from '../../../types/types';

export const emailReducerPesquisa = (state = {}, action = {}) => {
    let result = {};
    switch (action.type) {
        case types.EMAIL.PESQUISA:
            result = action.payload;
            break;
    
        default:
            result = state;
            break;
    }
    return result;
}

export const emailReducerPesquisaTipos = (state = {}, action = {}) => {
    let result = {};
    switch (action.type) {
        case types.EMAIL.PESQUISATIPOS:
            result = action.payload;
            break;
    
        default:
            result = state;
            break;
    }
    return result;
}

export const emailReducerPesquisaTiposEmails = (state = {}, action = {}) => {
    let result = {};
    switch (action.type) {
        case types.EMAIL.PESQUISATIPOSEMAIL:
            result = action.payload;
            break;
    
        default:
            result = state;
            break;
    }
    return result;
}

export const emailNovaAtualizaReducer = (state = {}, action = {}) => {
    let result = {};
    switch (action.type) {
        case types.EMAIL.NOVOATUALIZA:
            result = action.payload;
            break;    
        default:
            result = state;
            break;
    }
    return result;
}